// extracted by mini-css-extract-plugin
module.exports = {"mdBox":"mdBox-3gQacmFl","title":"title-1aHxsOB2","sofa":"sofa-dTSluEAg","join":"join-2IVrJ7WC","number":"number-3XCuGoZg"};